import { all, put, call } from 'redux-saga/effects'
import getMenuData from 'services/menu'
import RouteAccess from 'services/route_access'

export function* GET_DATA() {
  // var currentSelection = yield reduxStore.subscribe(() => {
  //   console.log(reduxStore.getState().accdetails)
  // })
  var menuData = yield call(getMenuData)
  var userAccess = localStorage.getItem('UserAcc')
  // var SelectedCluster = Common.getSelectedCluster(reduxStore.getState().accdetails)
  //   ? Common.getSelectedCluster(reduxStore.getState().accdetails)
  //   : ''
  // var SelectedScope = Common.getScope(reduxStore.getState().accdetails)
  //   ? Common.getScope(reduxStore.getState().accdetails)
  //   : ''
  if (userAccess === `${RouteAccess.USER} - ${RouteAccess.NO_ACCESS}`) {
    menuData = []
  }

  for (var i = 0; i < menuData.length; i++) {
    if (menuData[i]['children']) {
      var sysMenu = menuData[i]['children']
      let removeSysMenuElements = []
      for (var j = 0; j < sysMenu.length; j++) {
        if (sysMenu[j] !== undefined && !sysMenu[j]['roles'].includes(userAccess)) {
          removeSysMenuElements.push(j)
        }
      }
      var newSysMenu = []
      for (var j = 0; j < sysMenu.length; j++) {
        if (!removeSysMenuElements.includes(j)) {
          newSysMenu.push(sysMenu[j])
        }
      }
      menuData[i]['children'] = JSON.parse(JSON.stringify(newSysMenu))

      // A parent left with exactly ONE accessible child becomes a direct link
      // to that child, instead of a submenu the user must hover to open. For a
      // Viewer, System has only Collection Status, so the System icon opens
      // that page on click.
      //
      // Keyed on the filtered child count, not on the role: it falls out of the
      // filtering just above, so any future role/grant combination that leaves
      // one child behaves the same way with no change here.
      //
      // No menu-component change is needed. MenuLeft and MenuTop both branch on
      // `if (menuItem.children)` and fall through to generateItem(), which
      // builds the <Link> from urlEnd via Common.getPreURI() -- so deleting the
      // key is what turns the SubMenu into an Item. `url` is carried over too
      // because flattenItems(menuData, 'children') matches the selected item on
      // it when highlighting the active entry.
      if (newSysMenu.length === 1) {
        menuData[i]['url'] = newSysMenu[0]['url']
        menuData[i]['urlEnd'] = newSysMenu[0]['urlEnd']
        delete menuData[i]['children']
      }
    }
  }
  // }
  // if (SelectedCluster) {
  //   var scopes = []
  //   for (var i = 0; i < SelectedCluster['scope_access'].length; i++) {
  //     scopes.push(SelectedCluster['scope_access'][i].scope_id)
  //     if (
  //       SelectedCluster['scope_access'][i] === 'No Access' &&
  //       urlscope === SelectedCluster['scope_access'][i].scope_id
  //     ) {
  //       menuData = []
  //       // console.log(menuData)
  //     }
  //   }
  //   if (scopes.indexOf(SelectedScope.scope_id) === -1) {
  //     // console.log(scopes, scopes[SelectedScope.scope_id], SelectedScope.scope_id)
  //     menuData = []
  //   }
  // }
  window.onhashchange = function() {
    // window.location.reload(false)
  }
  // console.log(menuData, SelectedScope)
  yield put({
    type: 'menu/SET_STATE',
    payload: {
      menuData,
    },
  })
}

// const mapStateToProps = ({ user }) => ({
//   currentCluster: user.selectedCluster,
//   currentScope: user.selectScope,
// })
// @connect(mapStateToProps)

export default function* rootSaga() {
  yield all([
    GET_DATA(), // run once on app load to fetch menu data
  ])
}
